export default "/_next/static/chunks/fonts/AlegreyaSans-Regular-latin-e87baf5d810326afb8a20f486b55bd73.woff2";